import { generateId } from '@freelancer/datastore/testing/helpers';
import { ProjectTypeApi } from 'api-typings/projects/projects';
import type { ProjectBudgetOption } from '../project-budget-options/project-budget-options.model';
import type { Skill } from '../skills';
import type {
  ContestUpgradeCardOption,
  PostJobPageFormState,
  ProjectUpgradeCardOption,
} from './post-job-page-form-state.model';

export interface GenerateDraftOptions {
  readonly id: number;
  readonly userId: number;
  readonly submitDate: number | null;
  readonly title: string;
  readonly description: string;
  readonly contestDuration: number | null;
  readonly contestDurationType: string | null;
  readonly contestPrize: number | null;
  readonly contestType: ContestUpgradeCardOption | null;
  readonly currencyId: number | null;
  readonly isLocal: boolean | null;
  readonly jobType: string | null;
  readonly projectBudgetRange: ProjectBudgetOption | null;
  readonly projectBudgetType: string | null;
  readonly projectType: ProjectUpgradeCardOption | null;
  readonly skills: readonly Skill[] | null;
  readonly version?: number;
}

export function generatePjpDraftObject({
  id,
  userId = 1,
  submitDate = Date.now(),
  title,
  description,
  currencyId = null,
  jobType = null,
  projectBudgetRange = null,
  projectBudgetType = null,
  skills = null,
  version = 1,
}: GenerateDraftOptions): PostJobPageFormState {
  return {
    id: id ?? generateId(),
    userId,
    submitDate: submitDate ?? Date.now(),
    title,
    description,
    contestDuration: null,
    contestDurationType: null,
    contestPrize: null,
    contestType: null,
    currencyId,
    isLocal: null,
    jobType,
    projectBudgetRange,
    projectBudgetType,
    projectType: null,
    skills,
    version,
  };
}

export function customBudget(
  minimum: number = 15,
  maximum: number = 30,
  projectType: ProjectTypeApi = ProjectTypeApi.FIXED,
): ProjectBudgetOption {
  return {
    currencyId: 1,
    id: 'custom',
    maximum,
    minimum,
    name: 'Custom Budget',
    projectType,
  };
}
